var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-module-heroribbon"},[_c('ViewRibbon',{attrs:{"size":"large","animated":true}},[_c('a',{attrs:{"href":_vm.constants.LINK_TO_STEAM,"target":"_blank"}},[_vm._v(_vm._s(_vm.lang.get('home_header_text')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }